import { useState, useRef, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { GetDocument } from "../../Services";

const AddDocument = ({
  name,
  appliesTo,
  driver,
  documentId,
  setShowModal,
  onSuccess,
}) => {
  const [description, setDescription] = useState("");
  const [files, setFiles] = useState([]);
  // const [files, setFiles] = useState<File[]>([]);
  const [previewImage, setPreviewImage] = useState(null);
  const fileInputRef = useRef(null);

  // console.log("applies for :", name);
  // console.log("drivers: ", driver);
  // Initialize Bootstrap tooltips
  useEffect(() => {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, [files]);

  // Handle drag-and-drop and file input
  const handleFiles = (selectedFiles) => {
    const validFiles = Array.from(selectedFiles).filter(
      (file) =>
        file.size <= 10 * 1024 * 1024 && // 10MB limit
        ["image/jpeg", "image/png", "application/pdf"].includes(file.type)
    );

    if (validFiles.length + files.length > 5) {
      toast.error("Maximum 5 files allowed!", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    // Log selected file names
    validFiles.forEach((file) => {
      console.log("Selected file:", file.name);
    });

    setFiles((prevFiles) => [...prevFiles, ...validFiles]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove("dragover");
    handleFiles(e.dataTransfer.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.add("dragover");
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove("dragover");
  };

  const handleFileInputChange = (e) => {
    handleFiles(e.target.files);
    e.target.value = ""; // Reset input to allow re-uploading same file
  };

  const removeFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const viewFile = (file) => {
    const fileURL = URL.createObjectURL(file);
    if (file.type.startsWith("image/")) {
      setPreviewImage(fileURL); // Show in modal
      const modal = new window.bootstrap.Modal(
        document.getElementById("previewModal")
      );
      modal.show();
    } else if (file.type === "application/pdf") {
      window.open(fileURL, "_blank"); // Open PDF in new tab
    }
  };

  const downloadFile = (file) => {
    const fileURL = URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(fileURL); // Clean up
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!appliesTo) {
      toast.error("Document For is required", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (files.length === 0) {
      toast.error("Please select at least one file", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    const formData = new FormData();
    formData.append("documentTypeId", documentId);
    formData.append("name", name);
    files.forEach((file) => {
      formData.append("documents", file); // Changed from "files" to "documents"
      formData.append("filePath[]", file.name); // Send filenames
    });

    formData.append("reminder", description);
    formData.append("documentFor", appliesTo);
    if (driver?.id) formData.append("driverId", driver.id);
    // if (documentId) formData.append("documentId", documentId);

    try {
      // const response = await axios.post(
      //   "https://binberu.idaprocharity.com/api/v1/admin/upload-document",
      //   formData,
      //   {
      //     headers: { "Content-Type": "multipart/form-data" },
      //   }
      // );

      // console.log("request is here ", files);

      const response = await GetDocument.createDocument(formData);

      if (onSuccess) onSuccess();

      // setDrivers((prev) => [response.data.driver, ...prev]);

      console.log("✅ Document uploaded:", response.data);
      toast.success("Document uploaded successfully!", {
        position: "top-right",
        autoClose: 3000,
      });

      // Reset form and close modal
      setFiles([]);
      setDescription("");
      fileInputRef.current.value = "";
      setTimeout(() => setShowModal(false), 1500); // Delay to show toast
    } catch (error) {
      console.error("❌ Error uploading document:", error);
      toast.error(error.response?.data?.message || "Error uploading document", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 shadow-md rounded-xl">
      <h2 className="text-xl font-semibold mb-4">Add Document</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group mb-4">
          <label htmlFor="fileInput" className="col-form-label">
            Files *
          </label>
          <div
            className="card border-dashed h-100"
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <div className="card-body text-center py-5">
              <i className="fas fa-cloud-upload-alt fa-3x text-muted mb-3" />
              <h5 className="card-title">Drag & Drop Files Here</h5>
              <p className="card-text text-muted">
                Or click to browse (max 5 files, 10MB each, .jpg, .png, .pdf)
              </p>
              <input
                type="file"
                id="fileInput"
                multiple
                accept=".jpg,.png,.pdf"
                className="d-none"
                ref={fileInputRef}
                onChange={handleFileInputChange}
              />
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => fileInputRef.current.click()}
              >
                Choose Files
              </button>
            </div>
            <div className="list-group list-group-flush">
              {files.map((file, index) => (
                <div
                  key={index}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  <span>
                    {file.name} ({(file.size / 1024).toFixed(2)} KB)
                  </span>
                  <div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary px-2 py-1 me-2"
                      onClick={() => viewFile(file)}
                      data-bs-toggle="tooltip"
                      title="View"
                      aria-label="View file"
                    >
                      <i className="fas fa-eye" />
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary px-2 py-1 me-2"
                      onClick={() => downloadFile(file)}
                      data-bs-toggle="tooltip"
                      title="Download"
                      aria-label="Download file"
                    >
                      <i className="fas fa-download" />
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger px-2 py-1"
                      onClick={() => removeFile(index)}
                      data-bs-toggle="tooltip"
                      title="Remove"
                      aria-label="Remove file"
                    >
                      <i className="fas fa-trash" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="form-group mb-4">
          <label htmlFor="description" className="col-form-label">
            Description
          </label>
          <textarea
            className="form-control"
            rows="3"
            placeholder="Add if you have any description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div className="card-footer d-flex justify-content-between">
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </button>
        </div>
      </form>

      {/* Bootstrap Modal for Image Preview */}
      <div
        className="modal fade"
        id="previewModal"
        tabIndex="-1"
        aria-labelledby="previewModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="previewModalLabel">
                Image Preview
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setPreviewImage(null)}
              ></button>
            </div>
            <div className="modal-body text-center">
              {previewImage && (
                <img
                  src={previewImage}
                  alt="Preview"
                  className="img-fluid"
                  style={{ maxHeight: "60vh" }}
                />
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => setPreviewImage(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDocument;
